import { render, staticRenderFns } from "./LegendPlugin.vue?vue&type=template&id=dbd2c68a&scoped=true"
import script from "./LegendPlugin.vue?vue&type=script&lang=ts"
export * from "./LegendPlugin.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./LegendPlugin.vue?vue&type=style&index=0&id=dbd2c68a&prod&scoped=true&lang=less")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "dbd2c68a",
  null
  ,true
)

export default component.exports